var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"column":"","fill-height":"","justify-center":"","id":"mtp-0400"}},[_c('v-spacer'),_c('pre',{staticClass:"heading mb-10 text-center"},[_vm._v(_vm._s(_vm.$t('MTP-0400.001')))]),_c('pre',{staticClass:"heading mb-1"},[_vm._v(_vm._s(_vm.$t('MTP-0400.002')))]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }